import * as Config from '../../../config';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from "react-redux";
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { DragContext } from '../../../contexts/drag-context';
import { Root, Trigger } from "@radix-ui/react-context-menu";

import useNCItemList from "../nav-control/hooks/useNCItemList";

import {
  setTickItemID
} from "../../../actions/index";

function DragItem({
  type, item, style, idParent,
  begin, end, onClick, onMouseEnter = null, partialGrab = false,
  className, children,
  dnd = true,
  ContextMenuContent = null
}) {
  // v11 (rollback) :
  // const [, dragRef, preview] = useDrag({
  //   item: { ...item, type, idParent },
  //   begin: begin,
  //   end: end
  // })
  const [, dragRef, preview] = useDrag({
    type,
    item: () => {
      begin && begin();
      return { ...item, type, idParent };
    },
    end: end
  })
  const dispatch = useDispatch();

  // Custom Ghost with CustomDragLayerWrapper - Slow with HTML5Backend
  useEffect(() => { // HTML5 USE BUT TOUCH NO NEED
    preview(getEmptyImage(), { captureDraggingState: true })
  }, [preview])

  const isTick = useSelector( state => (state.tickItemID && state.tickItemID === `DI-${item.id}-TRACK`) );
  useEffect(() => {
    if (isTick) {
      setTimeout( () => {
        const el = document.getElementById(`DI-${item.id}-TRACK`);
        if (el) {
          // el.scrollIntoView();
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // el.style.border = `1px solid ${Config.BRAND_PRIMARY}`; //`1px solid #7217FF`;
          setTimeout( () => { 
            // el.style.border = null;
            dispatch(setTickItemID(null))
          }, 2000);
        }
      }, 500);
    }
  }, [isTick, item.id, dispatch])

  useNCItemList(idParent, item);

  // V1 - react-contextmenu
  // const onRightClick = (e) => {
  //   const el = document.getElementById(`more-ref-${item.id}`);
  //   if (el) {
  //     el.MClientX = e.clientX;
  //     el.MClientY = e.clientY;
  //     el.click();
  //   }
  // }

  // const isSelected = useSelector( state => (state.selectedItems && !!state.selectedItems.find(x => x.id === item.id) )); //OLD V1
  // V2
  const [selected, setSelected] = useState(false);
  const isSelected = useSelector( state => (state.selectedItems && !!state.selectedItems.find(x => x.id === item.id) ) )
  useEffect(() => {
    setSelected(isSelected);
  }, [isSelected])
 
  const playlistAutomix = useSelector(state => (!!state.uidAutomix) ? state.playlistAutomix : null);
  const automixClass = (playlistAutomix) ? 'automixON' : null;
  let isTrackAutomixPlaying = null;
  if (playlistAutomix && playlistAutomix.tracks) {
    let indexTrack = playlistAutomix.tracks.findIndex( (x) => x.id === item.id );
    isTrackAutomixPlaying = (indexTrack >= 0 && indexTrack === playlistAutomix.active) ? 'automixTrackPlaying' : null;
  }
  
  const onDeck = useSelector( state => (state.onAir && (state.onAir[0] === item.id)) ? 'deckA' : ( (state.onAir && (state.onAir[1] === item.id)) ? 'deckB' : null ));

  // CUSTOM BS - DJ Exclusives
  const extraClassName = ((item.genre && item.genre.slug && item.genre.slug === 'dj-exclusives')) ? 'dj-exclusives' : '';

  //<div id={`DI-${item.id}-${type}`} ref={ (!partialGrab && !Config.TOUCH_ENABLED && dnd) ? dragRef : null } onClick={onClick} onContextMenu={onRightClick} 
  return (
    <DragContext.Provider value={{ dragRef }}>
      <Root modal={false}>
        <Trigger asChild>
          <div id={`DI-${item.id}-${type}`} ref={ (!partialGrab && !Config.TOUCH_ENABLED && dnd) ? dragRef : null } onClick={onClick}
            onMouseEnter={(onMouseEnter) ? onMouseEnter : null}
            style={{ ...style }} className={`${className} ${selected && `selected`} ${extraClassName} ${automixClass} ${isTrackAutomixPlaying} ${onDeck} allow-menu`} >
            { React.Children.map(children, (child) => {
              if (React.isValidElement(child)) {
                return React.cloneElement(child, {})
              }
            }) }
          </div>
        </Trigger>
        { ContextMenuContent && <ContextMenuContent /> }
      </Root>
    </DragContext.Provider>
  );
}

DragItem.propTypes = {
  type: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  style: PropTypes.object,
  idParent: PropTypes.any,
  begin: PropTypes.func.isRequired,
  end: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string
}

export default DragItem;
